import toastTypes from "@constants/toast-types";
import { affiliationtrackingActions } from "@features/affiliation-tracking";
import axiosClient from "@features/axiosClient";
import { toastMessageActions } from "@features/ui/ToastMessage";
import { handleServerInteractionError } from "@utilities/services";

function showLoading(dispatch: any) {
  dispatch(affiliationtrackingActions.updateLoading(true));
}

function hideLoading(dispatch: any) {
  dispatch(affiliationtrackingActions.updateLoading(false));
}

export const getAffiliationTrackingList =
  (payload: any) => async (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
      const {
        providerNpi,
        providerLastName,
        providerDob,
        requestorName,
        requestorOrganizationName,
        requestorEmailAddress,
        requestorAddress,
        requestorCity,
        requestorState,
        requestorZip,
        isSubmit,
        pageIndex,
        pageSize,
      } = payload;
      showLoading(dispatch);
      try {
        const response = await axiosClient.get(
          `api/AveraTrackers/GetAffiliationTrackerData?ProviderNpi=${providerNpi}&ProviderLastName=${providerLastName}&ProviderDob=${providerDob}&RequestorName=${requestorName}&RequestorOrganizationName=${requestorOrganizationName}&RequestorEmailAddress=${requestorEmailAddress}&RequestorAddress=${requestorAddress}&RequestorCity=${requestorCity}&RequestorState=${requestorState}&RequestorZip=${requestorZip}&IsSubmit=${isSubmit}&PageIndex=${pageIndex}&PageSize=${pageSize}`
        );
        const data = response.data;

        if (response.status === 200) {
          dispatch(
            affiliationtrackingActions.updateAffiliationTrackingList(data)
          );
        } else {
          dispatch(
            toastMessageActions.showToast({
              message: "",
              type: toastTypes.DANGER,
            })
          );
        }
        hideLoading(dispatch);
        resolve(response);
      } catch (error) {
        handleServerInteractionError(dispatch);
        hideLoading(dispatch);
      }
    });
  };
